unit View.Rt_Is_Cst.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls,
  UHelperServer, WEBLib.Lists, WEBLib.Grids, Grid.Plugins, System.StrUtils,
  UConstantes, UUtils, UWeb.Enum;

type
  TFViewRt_Is_CstEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbcst: TLabel;
    edcst: TDBEdit;
    lbdescricao: TLabel;
    eddescricao: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientRt_Is_CstGet: TXDataWebClient;
    Rt_Is_CstDataset: TXDataWebDataSet;
    Rt_Is_CstDatasetid: TIntegerField;
    Rt_Is_CstDatasetcst: TStringField;
    Rt_Is_CstDatasetdescricao: TStringField;
    Rt_Is_CstDatasetexcluido: TBooleanField;
    Rt_Is_CstDatasetinclusao: TDateTimeField;
    Rt_Is_CstDatasetalteracao: TDateTimeField;
    Rt_Is_CstDatasetexclusao: TDateTimeField;
    cbExcluido: TDBCheckBox;
    pnlEspacoFormRtIsCst: TPanel;
    btnRtIsCst: TButton;
    lbTotalIsClassTributaria: TLabel;
    btnIsClassTributaria: TButton;
    pnlIsClassTributaria: TPanel;
    cbPageSizeIsClassTributaria: TComboBox;
    IsClassTributariaSearch: TEdit;
    tblIsClassTributaria: TDBTableControl;
    wlcIsClassTributaria: TListControl;
    dtsIsClassTributaria: TDataSource;
    cdsIsClassTributaria: TXDataWebDataSet;
    tmrConsultaIsClassTributaria: TTimer;
    cdsIsClassTributariaid: TIntegerField;
    cdsIsClassTributariart_is_cst_id: TIntegerField;
    cdsIsClassTributariacclasstrib: TStringField;
    cdsIsClassTributariadescricao: TStringField;
    cdsIsClassTributariaexcluido: TBooleanField;
    cdsIsClassTributariainclusao: TDateTimeField;
    cdsIsClassTributariaalteracao: TDateTimeField;
    cdsIsClassTributariaexclusao: TDateTimeField;
    pnlEspacoFormIsClassTributaria: TPanel;
    btnNovo: TButton;
    btnSalvarClassTrib: TButton;
    lbid_classtrib: TLabel;
    lbrt_is_cst_id: TLabel;
    lbcclasstrib: TLabel;
    edid_classtrib: TDBEdit;
    edcclasstrib: TDBEdit;
    cbbIsCstId: TComboBox;
    lbdescricao_classtrib: TLabel;
    eddescricao_classtrib: TDBEdit;
    lbexcluido_classtrib: TLabel;
    lbinclusao_classtrib: TLabel;
    lbalteracao_classtrib: TLabel;
    lbexclusao_classtrib: TLabel;
    edinclusao_classtrib: TDBEdit;
    edalteracao_classtrib: TDBEdit;
    ed_exclusao: TDBEdit;
    cbExcluidoClassTrib: TDBCheckBox;
    cdsIsClassTributariaEdit: TXDataWebDataSet;
    IntegerField1: TIntegerField;
    IntegerField2: TIntegerField;
    StringField1: TStringField;
    StringField2: TStringField;
    BooleanField1: TBooleanField;
    DateTimeField1: TDateTimeField;
    DateTimeField2: TDateTimeField;
    DateTimeField3: TDateTimeField;
    dtsIsClassTributariaEdit: TDataSource;
    cdsIsCst: TXDataWebDataSet;
    cdsIsCstid: TIntegerField;
    cdsIsCstdescricao: TStringField;
    cdsIsCstcst: TStringField;
    procedure btCancelClick(Sender: TObject);
    [async]
    procedure btSaveClick(Sender: TObject); async;
    procedure XDataClientRt_Is_CstGetLoad(Response: TXDataClientResponse);
    procedure Rt_Is_CstDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormShow(Sender: TObject);
    procedure edcstClick(Sender: TObject);
    procedure eddescricaoClick(Sender: TObject);
    procedure edcstKeyPress(Sender: TObject; var Key: Char);
    procedure btnIsClassTributariaClick(Sender: TObject);
    procedure tblIsClassTributariaGetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure tblIsClassTributariaGetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure tblIsClassTributariaGetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure btnNovoClick(Sender: TObject);
    procedure cdsIsCstAfterOpen(DataSet: TDataSet);
    procedure cdsIsClassTributariaEditAfterOpen(DataSet: TDataSet);
    [async]
    procedure btnSalvarClassTribClick(Sender: TObject); async;
    procedure cdsIsClassTributariaEditAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure cbbIsCstIdClick(Sender: TObject);
    procedure edcclasstribClick(Sender: TObject);
    procedure eddescricao_classtribClick(Sender: TObject);
    procedure edcclasstribKeyPress(Sender: TObject; var Key: Char);
    procedure IsClassTributariaSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure IsClassTributariaSearchKeyUp(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure tmrConsultaIsClassTributariaTimer(Sender: TObject);
    procedure cbPageSizeIsClassTributariaChange(Sender: TObject);
    procedure Rt_Is_CstDatasetAfterOpen(DataSet: TDataSet);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    FGridPluginIsClassTributaria : TGridPlugin;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
    function ValidarCampos(pRtIsCst : Boolean = True) : TArray<string>;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewRt_Is_CstEdit: TFViewRt_Is_CstEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewRt_Is_CstEdit }

procedure TFViewRt_Is_CstEdit.btnIsClassTributariaClick(Sender: TObject);
begin
  if not Assigned(FGridPluginIsClassTributaria) then
  begin
    FGridPluginIsClassTributaria := TGridPlugin.Create(tblIsClassTributaria,
      cdsIsClassTributaria, wlcIsClassTributaria, lbTotalIsClassTributaria);
    FGridPluginIsClassTributaria.FDatasetPlugin.FOrderByPadrao := 'id desc';
    FGridPluginIsClassTributaria.FDatasetPlugin.FFilterPadrao := 'rt_is_cst_id eq ' + edid.Text;
    FGridPluginIsClassTributaria.SetPageSize(StrToInt(cbPageSizeIsClassTributaria.Text));
    FGridPluginIsClassTributaria.SetFilterText(IsClassTributariaSearch.Text);
  end;

  FGridPluginIsClassTributaria.Load;
end;

procedure TFViewRt_Is_CstEdit.btnNovoClick(Sender: TObject);
begin
  TUtils.DesbloquearCamposDiv('camposFormClassTrib');
  btnSalvarClassTrib.Enabled := True;

  THelperServer.ElementoHide('div_campos_visualizar_class_trib');

  cdsIsClassTributariaEdit.Close;
  cdsIsClassTributariaEdit.SetJsonData('{}');
  cdsIsClassTributariaEdit.Open;
  cdsIsClassTributariaEdit.Insert;
end;

procedure TFViewRt_Is_CstEdit.btnSalvarClassTribClick(Sender: TObject);
var
  lErro : TArray<string>;
  lInserir : Boolean;
begin
  lErro := ValidarCampos(False);
  lInserir := Trim(edid_classtrib.Text) = '';

  if lErro[0] <> '' then
  begin
    TUtils.SetErroClass(lErro[1], lErro[0]);

    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, THelperServer.GetMensagemBotaoSalvar(lInserir,
    'Classificação Tributária'))) then
  begin
    TUtils.ChamarDivLoading;

    if cdsIsClassTributariaEdit.State in dsEditModes then
    begin
      cdsIsClassTributariaEdit.FieldByName('rt_is_cst_id').AsInteger := THelperServer.GetIdCombo(cdsIsCst,
        cbbIsCstId.ItemIndex);

      cdsIsClassTributariaEdit.Post;
      cdsIsClassTributariaEdit.ApplyUpdates;
    end;
  end;
end;

procedure TFViewRt_Is_CstEdit.btSaveClick(Sender: TObject);
var
  lErro : TArray<string>;
begin
  lErro := ValidarCampos;

  if lErro[0] <> '' then
  begin
    TUtils.SetErroClass(lErro[1], lErro[0]);

    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, THelperServer.GetMensagemBotaoSalvar(FInserting,
    'IS CST'))) then
  begin
    TUtils.ChamarDivLoading;

    if Rt_Is_CstDataset.State in dsEditModes then
    begin
          Rt_Is_CstDataset.Post;
      Rt_Is_CstDataset.ApplyUpdates;
    end
    else
      FShowListProc;
  end;
end;

procedure TFViewRt_Is_CstEdit.cbbIsCstIdClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_rt_is_class_tributaria_form_lbrt_is_cst_id');
end;

procedure TFViewRt_Is_CstEdit.cbPageSizeIsClassTributariaChange(
  Sender: TObject);
begin
  FGridPluginIsClassTributaria.SetPageSize(StrToInt(cbPageSizeIsClassTributaria.Text), True);
end;

procedure TFViewRt_Is_CstEdit.cdsIsClassTributariaEditAfterApplyUpdates(
  Sender: TDataSet; Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);

      cdsIsClassTributariaEdit.Edit;

      Exit;
    end;
  end;

  TUtils.CloseModal('modal_is_class_tributaria');
  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Operação realizada com sucesso!');
  FGridPluginIsClassTributaria.Load;
end;

procedure TFViewRt_Is_CstEdit.cdsIsClassTributariaEditAfterOpen(
  DataSet: TDataSet);
begin
  THelperServer.SetIndexCombo(cdsIsCst, StrToInt(edid.Text), cbbIsCstId);

  if Trim(edid_classtrib.Text) <> '' then
    THelperServer.ElementoShow('div_campos_visualizar_class_trib');

  TUtils.OpenModal('modal_is_class_tributaria');
end;

procedure TFViewRt_Is_CstEdit.cdsIsCstAfterOpen(DataSet: TDataSet);
begin
  THelperServer.ConverterCdsEmCombo(cdsIsCst, cbbIsCstId);
end;

class function TFViewRt_Is_CstEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewRt_Is_CstEdit.edcclasstribClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_rt_is_class_tributaria_form_lbcclasstrib');
end;

procedure TFViewRt_Is_CstEdit.edcclasstribKeyPress(Sender: TObject;
  var Key: Char);
begin
  if not(key in ['0'..'9']) Then
    key := #0;
end;

procedure TFViewRt_Is_CstEdit.edcstClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_rt_is_cst_form_lbcst');
end;

procedure TFViewRt_Is_CstEdit.edcstKeyPress(Sender: TObject; var Key: Char);
begin
  if not(key in ['0'..'9']) Then
    key := #0;
end;

procedure TFViewRt_Is_CstEdit.eddescricaoClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_rt_is_cst_form_lbdescricao');
end;

procedure TFViewRt_Is_CstEdit.eddescricao_classtribClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('view_rt_is_class_tributaria_form_lbdescricao');
end;

procedure TFViewRt_Is_CstEdit.InsertEntity;
begin
  Rt_Is_CstDataset.Close;
  Rt_Is_CstDataset.SetJsonData('{}');
  Rt_Is_CstDataset.Open;
  Rt_Is_CstDataset.Insert;
end;

class function TFViewRt_Is_CstEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewRt_Is_CstEdit(AForm).FInserting := AInserting;
    TFViewRt_Is_CstEdit(AForm).FId := AId;
    TFViewRt_Is_CstEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewRt_Is_CstEdit(AForm).InsertEntity
    else
      TFViewRt_Is_CstEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewRt_Is_CstEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewRt_Is_CstEdit.IsClassTributariaSearchKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsultaIsClassTributaria.Enabled := False;

  if Key = 13 then
  begin
    FGridPluginIsClassTributaria.SetFilterText(IsClassTributariaSearch.Text, True);
  end;
end;

procedure TFViewRt_Is_CstEdit.IsClassTributariaSearchKeyUp(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsultaIsClassTributaria.Interval := FTimerConsulta;
  tmrConsultaIsClassTributaria.Enabled := True;
end;

procedure TFViewRt_Is_CstEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Rt_Is_CstDataset.Connection.Model.DefaultSchema.FindEntityType(
      Rt_Is_CstDataset.EntitySetName
    )
  );
  XDataClientRt_Is_CstGet.Get(Rt_Is_CstDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewRt_Is_CstEdit.ShowNotification(Notification: string);
begin
  TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, Notification);
end;

procedure TFViewRt_Is_CstEdit.tblIsClassTributariaGetCellChildren(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordCdsCurrent: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    cdsIsClassTributariaEdit.Close;
    cdsIsClassTributariaEdit.SetJsonData(RecordCdsCurrent);
    cdsIsClassTributariaEdit.Open;
    cdsIsClassTributariaEdit.Edit;

    if not TUtils.PossuiPermissao(cdsIsClassTributaria.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
    begin
      TUtils.BloquearCamposDiv('camposFormClassTrib');
      btnSalvarClassTrib.Enabled := False;
    end;
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if tblIsClassTributaria.Columns[ACol].Title = 'Ação' then
  begin
    RecordCdsCurrent := cdsIsClassTributaria.CurrentData;

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fa fa-edit"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_is_class_tributaria');
  end;
end;

procedure TFViewRt_Is_CstEdit.tblIsClassTributariaGetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(tblIsClassTributaria.Columns[ACol].DataField, ['descricao']) of
      0: AClassName := 'text-left';
    else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewRt_Is_CstEdit.tblIsClassTributariaGetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(tblIsClassTributaria.Columns[ACol].DataField, ['excluido', 'descricao']) of
      0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
      1:
      begin
        if Length(AValue) > 100 then
          AValue := Copy(AValue, 1, 100) + '...';
      end;
    end;
  end;
end;

procedure TFViewRt_Is_CstEdit.tmrConsultaIsClassTributariaTimer(
  Sender: TObject);
begin
  FGridPluginIsClassTributaria.SetFilterText(IsClassTributariaSearch.Text, True);

  tmrConsultaIsClassTributaria.Enabled := False;
  tmrConsultaIsClassTributaria.Interval := FTimerConsulta;
end;

function TFViewRt_Is_CstEdit.ValidarCampos(pRtIsCst: Boolean): TArray<string>;
begin
  TUtils.LimparErrosClass;

  SetLength(Result, 2);
  Result[0] := '';
  Result[1] := 'view_rt_is_cst_form_lbcst';

  if pRtIsCst then
  begin
    if Trim(edcst.Text) = '' then
    begin
      Result[0] := 'CST não pode ser vazio!';
      Result[1] := 'view_rt_is_cst_form_lbcst';
      Exit;
    end;

    if Trim(eddescricao.Text) = '' then
    begin
      Result[0] := 'Descrição não pode ser vazia!';
      Result[1] := 'view_rt_is_cst_form_lbdescricao';
      Exit;
    end;
  end
  else
  begin
    if Trim(cbbIsCstId.Text) = '' then
    begin
      Result[0] := 'Selecione o IS CST!';
      Result[1] := 'view_rt_is_class_tributaria_form_lbrt_is_cst_id';
      Exit;
    end;

    if Trim(edcclasstrib.Text) = '' then
    begin
      Result[0] := 'CCLASSTRIB não pode ser vazio!';
      Result[1] := 'view_rt_is_class_tributaria_form_lbcclasstrib';
      Exit;
    end;


    if Trim(eddescricao_classtrib.Text) = '' then
    begin
      Result[0] := 'Descrição não pode ser vazia!';
      Result[1] := 'view_rt_is_class_tributaria_form_lbdescricao';
      Exit;
    end;
  end;
end;

procedure TFViewRt_Is_CstEdit.WebFormShow(Sender: TObject);
begin
  if FInserting or not TUtils.PossuiPermissao(cdsIsClassTributaria.EntitySetName.ToLower, TTipoPermissao.VISUALIZAR) then
  begin
    THelperServer.RemoverElementoPorId(btnIsClassTributaria.ElementID);
    THelperServer.RemoverElementoPorId('line-rt_is_class_tributaria');
    THelperServer.RemoverElementoPorId('modal_is_class_tributaria');
  end;

  if FInserting then
  begin
    THelperServer.RemoverElementoPorId('div_campos_visualizar');

    if edcst.CanFocus then
      edcst.SetFocus;
  end
  else
  begin
    if TUtils.PossuiPermissao(cdsIsClassTributaria.EntitySetName.ToLower, TTipoPermissao.VISUALIZAR) then
      cdsIsCst.Load;

    btnNovo.Enabled := TUtils.PossuiPermissao(cdsIsClassTributaria.EntitySetName.ToLower, TTipoPermissao.INSERIR);
  end;
end;

procedure TFViewRt_Is_CstEdit.XDataClientRt_Is_CstGetLoad(Response: TXDataClientResponse);
begin
  Rt_Is_CstDataset.Close;
  Rt_Is_CstDataset.SetJsonData(Response.Result);
  Rt_Is_CstDataset.Open;
  
  Rt_Is_CstDataset.Edit;  
end;

procedure TFViewRt_Is_CstEdit.Rt_Is_CstDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];

    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);

      Rt_Is_CstDataset.Edit;

      Exit;
    end;
  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, 'Operação realizada com sucesso!');
  FShowListProc;
end;

procedure TFViewRt_Is_CstEdit.Rt_Is_CstDatasetAfterOpen(DataSet: TDataSet);
begin
  if not TUtils.PossuiPermissao(Rt_Is_CstDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
  begin
    btSave.Enabled := False;

    asm
      window.setTimeout(function() {
        pas.UUtils.TUtils.BloquearCamposDiv('camposFormRtIsCst');
      }, 200);
    end;
  end;
end;

procedure TFViewRt_Is_CstEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewRt_Is_CstEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.rt_is_cst.form.lbid');
  lbcst := TLabel.Create('view.rt_is_cst.form.lbcst');
  lbdescricao := TLabel.Create('view.rt_is_cst.form.lbdescricao');
  lbexcluido := TLabel.Create('view.rt_is_cst.form.lbexcluido');
  lbinclusao := TLabel.Create('view.rt_is_cst.form.lbinclusao');
  lbalteracao := TLabel.Create('view.rt_is_cst.form.lbalteracao');
  lbexclusao := TLabel.Create('view.rt_is_cst.form.lbexclusao');
  lbTotalIsClassTributaria := TLabel.Create('lbTotalIsClassTributaria');
  lbid_classtrib := TLabel.Create('view.rt_is_class_tributaria.form.lbid');
  lbrt_is_cst_id := TLabel.Create('view.rt_is_class_tributaria.form.lbrt_is_cst_id');
  lbcclasstrib := TLabel.Create('view.rt_is_class_tributaria.form.lbcclasstrib');
  lbdescricao_classtrib := TLabel.Create('view.rt_is_class_tributaria.form.lbdescricao');
  lbexcluido_classtrib := TLabel.Create('view.rt_is_class_tributaria.form.lbexcluido');
  lbinclusao_classtrib := TLabel.Create('view.rt_is_class_tributaria.form.lbinclusao');
  lbalteracao_classtrib := TLabel.Create('view.rt_is_class_tributaria.form.lbalteracao');
  lbexclusao_classtrib := TLabel.Create('view.rt_is_class_tributaria.form.lbexclusao');
  btCancel := TButton.Create('view.rt_is_cst.form.btBack');
  btSave := TButton.Create('view.rt_is_cst.form.btSave');
  edid := TDBEdit.Create('view.rt_is_cst.form.edid');
  edcst := TDBEdit.Create('view.rt_is_cst.form.edcst');
  eddescricao := TDBEdit.Create('view.rt_is_cst.form.eddescricao');
  edinclusao := TDBEdit.Create('view.rt_is_cst.form.edinclusao');
  edalteracao := TDBEdit.Create('view.rt_is_cst.form.edalteracao');
  edexclusao := TDBEdit.Create('view.rt_is_cst.form.edexclusao');
  cbExcluido := TDBCheckBox.Create('view.rt_is_cst.form.cbexcluido');
  pnlEspacoFormRtIsCst := TPanel.Create(Self);
  btnRtIsCst := TButton.Create('line-rt_is_cst-tab');
  btnIsClassTributaria := TButton.Create('line-rt_is_class_tributaria-tab');
  pnlIsClassTributaria := TPanel.Create(Self);
  cbPageSizeIsClassTributaria := TComboBox.Create('cbPageSizeIsClassTributaria');
  IsClassTributariaSearch := TEdit.Create('IsClassTributariaSearch');
  tblIsClassTributaria := TDBTableControl.Create('tblIsClassTributaria');
  wlcIsClassTributaria := TListControl.Create('wlcIsClassTributaria');
  pnlEspacoFormIsClassTributaria := TPanel.Create(Self);
  btnNovo := TButton.Create('view.rt_is_cst.edit.newbutton');
  btnSalvarClassTrib := TButton.Create('view.rt_is_class_tributaria.form.btSave');
  edid_classtrib := TDBEdit.Create('view.rt_is_class_tributaria.form.edid');
  edcclasstrib := TDBEdit.Create('view.rt_is_class_tributaria.form.edcclasstrib');
  cbbIsCstId := TComboBox.Create('view.rt_is_class_tributaria.form.cbrt_ibs_cbs_cst_id');
  eddescricao_classtrib := TDBEdit.Create('view.rt_is_class_tributaria.form.eddescricao');
  edinclusao_classtrib := TDBEdit.Create('view.rt_is_class_tributaria.form.edinclusao');
  edalteracao_classtrib := TDBEdit.Create('view.rt_is_class_tributaria.form.edalteracao');
  ed_exclusao := TDBEdit.Create('view.rt_is_class_tributaria.form.edexclusao');
  cbExcluidoClassTrib := TDBCheckBox.Create('view.rt_is_class_tributaria.form.cbexcluido');
  DataSource := TDataSource.Create(Self);
  Rt_Is_CstDataset := TXDataWebDataSet.Create(Self);
  Rt_Is_CstDatasetid := TIntegerField.Create(Self);
  Rt_Is_CstDatasetcst := TStringField.Create(Self);
  Rt_Is_CstDatasetdescricao := TStringField.Create(Self);
  Rt_Is_CstDatasetexcluido := TBooleanField.Create(Self);
  Rt_Is_CstDatasetinclusao := TDateTimeField.Create(Self);
  Rt_Is_CstDatasetalteracao := TDateTimeField.Create(Self);
  Rt_Is_CstDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientRt_Is_CstGet := TXDataWebClient.Create(Self);
  dtsIsClassTributaria := TDataSource.Create(Self);
  cdsIsClassTributaria := TXDataWebDataSet.Create(Self);
  cdsIsClassTributariaid := TIntegerField.Create(Self);
  cdsIsClassTributariart_is_cst_id := TIntegerField.Create(Self);
  cdsIsClassTributariacclasstrib := TStringField.Create(Self);
  cdsIsClassTributariadescricao := TStringField.Create(Self);
  cdsIsClassTributariaexcluido := TBooleanField.Create(Self);
  cdsIsClassTributariainclusao := TDateTimeField.Create(Self);
  cdsIsClassTributariaalteracao := TDateTimeField.Create(Self);
  cdsIsClassTributariaexclusao := TDateTimeField.Create(Self);
  tmrConsultaIsClassTributaria := TTimer.Create(Self);
  cdsIsClassTributariaEdit := TXDataWebDataSet.Create(Self);
  IntegerField1 := TIntegerField.Create(Self);
  IntegerField2 := TIntegerField.Create(Self);
  StringField1 := TStringField.Create(Self);
  StringField2 := TStringField.Create(Self);
  BooleanField1 := TBooleanField.Create(Self);
  DateTimeField1 := TDateTimeField.Create(Self);
  DateTimeField2 := TDateTimeField.Create(Self);
  DateTimeField3 := TDateTimeField.Create(Self);
  dtsIsClassTributariaEdit := TDataSource.Create(Self);
  cdsIsCst := TXDataWebDataSet.Create(Self);
  cdsIsCstid := TIntegerField.Create(Self);
  cdsIsCstdescricao := TStringField.Create(Self);
  cdsIsCstcst := TStringField.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbcst.BeforeLoadDFMValues;
  lbdescricao.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  lbTotalIsClassTributaria.BeforeLoadDFMValues;
  lbid_classtrib.BeforeLoadDFMValues;
  lbrt_is_cst_id.BeforeLoadDFMValues;
  lbcclasstrib.BeforeLoadDFMValues;
  lbdescricao_classtrib.BeforeLoadDFMValues;
  lbexcluido_classtrib.BeforeLoadDFMValues;
  lbinclusao_classtrib.BeforeLoadDFMValues;
  lbalteracao_classtrib.BeforeLoadDFMValues;
  lbexclusao_classtrib.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edcst.BeforeLoadDFMValues;
  eddescricao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbExcluido.BeforeLoadDFMValues;
  pnlEspacoFormRtIsCst.BeforeLoadDFMValues;
  btnRtIsCst.BeforeLoadDFMValues;
  btnIsClassTributaria.BeforeLoadDFMValues;
  pnlIsClassTributaria.BeforeLoadDFMValues;
  cbPageSizeIsClassTributaria.BeforeLoadDFMValues;
  IsClassTributariaSearch.BeforeLoadDFMValues;
  tblIsClassTributaria.BeforeLoadDFMValues;
  wlcIsClassTributaria.BeforeLoadDFMValues;
  pnlEspacoFormIsClassTributaria.BeforeLoadDFMValues;
  btnNovo.BeforeLoadDFMValues;
  btnSalvarClassTrib.BeforeLoadDFMValues;
  edid_classtrib.BeforeLoadDFMValues;
  edcclasstrib.BeforeLoadDFMValues;
  cbbIsCstId.BeforeLoadDFMValues;
  eddescricao_classtrib.BeforeLoadDFMValues;
  edinclusao_classtrib.BeforeLoadDFMValues;
  edalteracao_classtrib.BeforeLoadDFMValues;
  ed_exclusao.BeforeLoadDFMValues;
  cbExcluidoClassTrib.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Rt_Is_CstDataset.BeforeLoadDFMValues;
  Rt_Is_CstDatasetid.BeforeLoadDFMValues;
  Rt_Is_CstDatasetcst.BeforeLoadDFMValues;
  Rt_Is_CstDatasetdescricao.BeforeLoadDFMValues;
  Rt_Is_CstDatasetexcluido.BeforeLoadDFMValues;
  Rt_Is_CstDatasetinclusao.BeforeLoadDFMValues;
  Rt_Is_CstDatasetalteracao.BeforeLoadDFMValues;
  Rt_Is_CstDatasetexclusao.BeforeLoadDFMValues;
  XDataClientRt_Is_CstGet.BeforeLoadDFMValues;
  dtsIsClassTributaria.BeforeLoadDFMValues;
  cdsIsClassTributaria.BeforeLoadDFMValues;
  cdsIsClassTributariaid.BeforeLoadDFMValues;
  cdsIsClassTributariart_is_cst_id.BeforeLoadDFMValues;
  cdsIsClassTributariacclasstrib.BeforeLoadDFMValues;
  cdsIsClassTributariadescricao.BeforeLoadDFMValues;
  cdsIsClassTributariaexcluido.BeforeLoadDFMValues;
  cdsIsClassTributariainclusao.BeforeLoadDFMValues;
  cdsIsClassTributariaalteracao.BeforeLoadDFMValues;
  cdsIsClassTributariaexclusao.BeforeLoadDFMValues;
  tmrConsultaIsClassTributaria.BeforeLoadDFMValues;
  cdsIsClassTributariaEdit.BeforeLoadDFMValues;
  IntegerField1.BeforeLoadDFMValues;
  IntegerField2.BeforeLoadDFMValues;
  StringField1.BeforeLoadDFMValues;
  StringField2.BeforeLoadDFMValues;
  BooleanField1.BeforeLoadDFMValues;
  DateTimeField1.BeforeLoadDFMValues;
  DateTimeField2.BeforeLoadDFMValues;
  DateTimeField3.BeforeLoadDFMValues;
  dtsIsClassTributariaEdit.BeforeLoadDFMValues;
  cdsIsCst.BeforeLoadDFMValues;
  cdsIsCstid.BeforeLoadDFMValues;
  cdsIsCstdescricao.BeforeLoadDFMValues;
  cdsIsCstcst.BeforeLoadDFMValues;
  try
    Name := 'FViewRt_Is_CstEdit';
    Width := 689;
    Height := 620;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 8;
    lbid.Top := 40;
    lbid.Width := 23;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbcst.SetParentComponent(Self);
    lbcst.Name := 'lbcst';
    lbcst.Left := 8;
    lbcst.Top := 67;
    lbcst.Width := 23;
    lbcst.Height := 13;
    lbcst.Caption := 'CST:';
    lbcst.HeightPercent := 100.000000000000000000;
    lbcst.WidthPercent := 100.000000000000000000;
    lbdescricao.SetParentComponent(Self);
    lbdescricao.Name := 'lbdescricao';
    lbdescricao.Left := 8;
    lbdescricao.Top := 94;
    lbdescricao.Width := 50;
    lbdescricao.Height := 13;
    lbdescricao.Caption := 'Descri'#231#227'o:';
    lbdescricao.HeightPercent := 100.000000000000000000;
    lbdescricao.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 8;
    lbexcluido.Top := 121;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 8;
    lbinclusao.Top := 148;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 8;
    lbalteracao.Top := 175;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 8;
    lbexclusao.Top := 202;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    lbTotalIsClassTributaria.SetParentComponent(Self);
    lbTotalIsClassTributaria.Name := 'lbTotalIsClassTributaria';
    lbTotalIsClassTributaria.Left := 344;
    lbTotalIsClassTributaria.Top := 218;
    lbTotalIsClassTributaria.Width := 141;
    lbTotalIsClassTributaria.Height := 13;
    lbTotalIsClassTributaria.Caption := 'Showing 1 to 10 of 57 entries';
    lbTotalIsClassTributaria.HeightPercent := 100.000000000000000000;
    lbTotalIsClassTributaria.WidthPercent := 100.000000000000000000;
    lbid_classtrib.SetParentComponent(Self);
    lbid_classtrib.Name := 'lbid_classtrib';
    lbid_classtrib.Left := 8;
    lbid_classtrib.Top := 336;
    lbid_classtrib.Width := 23;
    lbid_classtrib.Height := 13;
    lbid_classtrib.Caption := 'C'#243'd:';
    lbid_classtrib.HeightPercent := 100.000000000000000000;
    lbid_classtrib.WidthPercent := 100.000000000000000000;
    lbrt_is_cst_id.SetParentComponent(Self);
    lbrt_is_cst_id.Name := 'lbrt_is_cst_id';
    lbrt_is_cst_id.Left := 8;
    lbrt_is_cst_id.Top := 363;
    lbrt_is_cst_id.Width := 36;
    lbrt_is_cst_id.Height := 13;
    lbrt_is_cst_id.Caption := 'IS CST:';
    lbrt_is_cst_id.HeightPercent := 100.000000000000000000;
    lbrt_is_cst_id.WidthPercent := 100.000000000000000000;
    lbcclasstrib.SetParentComponent(Self);
    lbcclasstrib.Name := 'lbcclasstrib';
    lbcclasstrib.Left := 8;
    lbcclasstrib.Top := 390;
    lbcclasstrib.Width := 65;
    lbcclasstrib.Height := 13;
    lbcclasstrib.Caption := 'CCLASSTRIB:';
    lbcclasstrib.HeightPercent := 100.000000000000000000;
    lbcclasstrib.WidthPercent := 100.000000000000000000;
    lbdescricao_classtrib.SetParentComponent(Self);
    lbdescricao_classtrib.Name := 'lbdescricao_classtrib';
    lbdescricao_classtrib.Left := 8;
    lbdescricao_classtrib.Top := 417;
    lbdescricao_classtrib.Width := 50;
    lbdescricao_classtrib.Height := 13;
    lbdescricao_classtrib.Caption := 'Descri'#231#227'o:';
    lbdescricao_classtrib.HeightPercent := 100.000000000000000000;
    lbdescricao_classtrib.WidthPercent := 100.000000000000000000;
    lbexcluido_classtrib.SetParentComponent(Self);
    lbexcluido_classtrib.Name := 'lbexcluido_classtrib';
    lbexcluido_classtrib.Left := 336;
    lbexcluido_classtrib.Top := 336;
    lbexcluido_classtrib.Width := 43;
    lbexcluido_classtrib.Height := 13;
    lbexcluido_classtrib.Caption := 'Exclu'#237'do:';
    lbexcluido_classtrib.HeightPercent := 100.000000000000000000;
    lbexcluido_classtrib.WidthPercent := 100.000000000000000000;
    lbinclusao_classtrib.SetParentComponent(Self);
    lbinclusao_classtrib.Name := 'lbinclusao_classtrib';
    lbinclusao_classtrib.Left := 336;
    lbinclusao_classtrib.Top := 363;
    lbinclusao_classtrib.Width := 44;
    lbinclusao_classtrib.Height := 13;
    lbinclusao_classtrib.Caption := 'Inclus'#227'o:';
    lbinclusao_classtrib.HeightPercent := 100.000000000000000000;
    lbinclusao_classtrib.WidthPercent := 100.000000000000000000;
    lbalteracao_classtrib.SetParentComponent(Self);
    lbalteracao_classtrib.Name := 'lbalteracao_classtrib';
    lbalteracao_classtrib.Left := 336;
    lbalteracao_classtrib.Top := 390;
    lbalteracao_classtrib.Width := 50;
    lbalteracao_classtrib.Height := 13;
    lbalteracao_classtrib.Caption := 'Altera'#231#227'o:';
    lbalteracao_classtrib.HeightPercent := 100.000000000000000000;
    lbalteracao_classtrib.WidthPercent := 100.000000000000000000;
    lbexclusao_classtrib.SetParentComponent(Self);
    lbexclusao_classtrib.Name := 'lbexclusao_classtrib';
    lbexclusao_classtrib.Left := 336;
    lbexclusao_classtrib.Top := 417;
    lbexclusao_classtrib.Width := 46;
    lbexclusao_classtrib.Height := 13;
    lbexclusao_classtrib.Caption := 'Exclus'#227'o:';
    lbexclusao_classtrib.HeightPercent := 100.000000000000000000;
    lbexclusao_classtrib.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 217;
    btCancel.Top := 93;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 217;
    btSave.Top := 62;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 69;
    edid.Top := 37;
    edid.Width := 130;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edcst.SetParentComponent(Self);
    edcst.Name := 'edcst';
    edcst.Left := 69;
    edcst.Top := 64;
    edcst.Width := 130;
    edcst.Height := 21;
    edcst.HeightPercent := 100.000000000000000000;
    edcst.MaxLength := 3;
    edcst.TabOrder := 7;
    edcst.Text := 'edcst';
    edcst.WidthPercent := 100.000000000000000000;
    SetEvent(edcst, Self, 'OnClick', 'edcstClick');
    SetEvent(edcst, Self, 'OnKeyPress', 'edcstKeyPress');
    edcst.DataField := 'cst';
    edcst.DataSource := DataSource;
    eddescricao.SetParentComponent(Self);
    eddescricao.Name := 'eddescricao';
    eddescricao.Left := 69;
    eddescricao.Top := 91;
    eddescricao.Width := 130;
    eddescricao.Height := 21;
    eddescricao.HeightPercent := 100.000000000000000000;
    eddescricao.TabOrder := 8;
    eddescricao.Text := 'eddescricao';
    eddescricao.WidthPercent := 100.000000000000000000;
    SetEvent(eddescricao, Self, 'OnClick', 'eddescricaoClick');
    eddescricao.DataField := 'descricao';
    eddescricao.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 69;
    edinclusao.Top := 145;
    edinclusao.Width := 130;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 10;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 69;
    edalteracao.Top := 172;
    edalteracao.Width := 130;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 11;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 69;
    edexclusao.Top := 199;
    edexclusao.Width := 130;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 12;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbExcluido.SetParentComponent(Self);
    cbExcluido.Name := 'cbExcluido';
    cbExcluido.Left := 69;
    cbExcluido.Top := 118;
    cbExcluido.Width := 130;
    cbExcluido.Height := 22;
    cbExcluido.Caption := 'cbExcluido';
    cbExcluido.ChildOrder := 13;
    cbExcluido.HeightPercent := 100.000000000000000000;
    cbExcluido.WidthPercent := 100.000000000000000000;
    cbExcluido.DataField := 'excluido';
    cbExcluido.DataSource := DataSource;
    pnlEspacoFormRtIsCst.SetParentComponent(Self);
    pnlEspacoFormRtIsCst.Name := 'pnlEspacoFormRtIsCst';
    pnlEspacoFormRtIsCst.Left := 8;
    pnlEspacoFormRtIsCst.Top := 8;
    pnlEspacoFormRtIsCst.Width := 305;
    pnlEspacoFormRtIsCst.Height := 17;
    pnlEspacoFormRtIsCst.Caption := 'Espa'#231'o form Rt Is Cst';
    pnlEspacoFormRtIsCst.ChildOrder := 23;
    pnlEspacoFormRtIsCst.Color := clInfoText;
    pnlEspacoFormRtIsCst.Font.Charset := DEFAULT_CHARSET;
    pnlEspacoFormRtIsCst.Font.Color := clWhite;
    pnlEspacoFormRtIsCst.Font.Height := -11;
    pnlEspacoFormRtIsCst.Font.Name := 'Tahoma';
    pnlEspacoFormRtIsCst.Font.Style := [fsBold];
    pnlEspacoFormRtIsCst.ParentFont := False;
    pnlEspacoFormRtIsCst.TabOrder := 9;
    pnlEspacoFormRtIsCst.Visible := False;
    btnRtIsCst.SetParentComponent(Self);
    btnRtIsCst.Name := 'btnRtIsCst';
    btnRtIsCst.Left := 217;
    btnRtIsCst.Top := 31;
    btnRtIsCst.Width := 96;
    btnRtIsCst.Height := 25;
    btnRtIsCst.Caption := 'IS CST';
    btnRtIsCst.ChildOrder := 16;
    btnRtIsCst.HeightPercent := 100.000000000000000000;
    btnRtIsCst.WidthPercent := 100.000000000000000000;
    btnIsClassTributaria.SetParentComponent(Self);
    btnIsClassTributaria.Name := 'btnIsClassTributaria';
    btnIsClassTributaria.Left := 583;
    btnIsClassTributaria.Top := 27;
    btnIsClassTributaria.Width := 96;
    btnIsClassTributaria.Height := 25;
    btnIsClassTributaria.Caption := 'Classifica'#231#227'o Tribut'#225'ria';
    btnIsClassTributaria.ChildOrder := 16;
    btnIsClassTributaria.HeightPercent := 100.000000000000000000;
    btnIsClassTributaria.WidthPercent := 100.000000000000000000;
    SetEvent(btnIsClassTributaria, Self, 'OnClick', 'btnIsClassTributariaClick');
    pnlIsClassTributaria.SetParentComponent(Self);
    pnlIsClassTributaria.Name := 'pnlIsClassTributaria';
    pnlIsClassTributaria.Left := 336;
    pnlIsClassTributaria.Top := 8;
    pnlIsClassTributaria.Width := 343;
    pnlIsClassTributaria.Height := 17;
    pnlIsClassTributaria.Caption := 'Espa'#231'o tabela Rt Is Class Tributaria';
    pnlIsClassTributaria.ChildOrder := 23;
    pnlIsClassTributaria.Color := clInfoText;
    pnlIsClassTributaria.Font.Charset := DEFAULT_CHARSET;
    pnlIsClassTributaria.Font.Color := clWhite;
    pnlIsClassTributaria.Font.Height := -11;
    pnlIsClassTributaria.Font.Name := 'Tahoma';
    pnlIsClassTributaria.Font.Style := [fsBold];
    pnlIsClassTributaria.ParentFont := False;
    pnlIsClassTributaria.TabOrder := 12;
    pnlIsClassTributaria.Visible := False;
    cbPageSizeIsClassTributaria.SetParentComponent(Self);
    cbPageSizeIsClassTributaria.Name := 'cbPageSizeIsClassTributaria';
    cbPageSizeIsClassTributaria.Left := 480;
    cbPageSizeIsClassTributaria.Top := 31;
    cbPageSizeIsClassTributaria.Width := 97;
    cbPageSizeIsClassTributaria.Height := 21;
    cbPageSizeIsClassTributaria.HeightPercent := 100.000000000000000000;
    cbPageSizeIsClassTributaria.TabOrder := 2;
    cbPageSizeIsClassTributaria.Text := '10';
    cbPageSizeIsClassTributaria.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSizeIsClassTributaria, Self, 'OnChange', 'cbPageSizeIsClassTributariaChange');
    cbPageSizeIsClassTributaria.ItemIndex := 0;
    cbPageSizeIsClassTributaria.Items.BeginUpdate;
    try
      cbPageSizeIsClassTributaria.Items.Clear;
      cbPageSizeIsClassTributaria.Items.Add('10');
      cbPageSizeIsClassTributaria.Items.Add('25');
      cbPageSizeIsClassTributaria.Items.Add('50');
      cbPageSizeIsClassTributaria.Items.Add('100');
    finally
      cbPageSizeIsClassTributaria.Items.EndUpdate;
    end;
    IsClassTributariaSearch.SetParentComponent(Self);
    IsClassTributariaSearch.Name := 'IsClassTributariaSearch';
    IsClassTributariaSearch.Left := 344;
    IsClassTributariaSearch.Top := 31;
    IsClassTributariaSearch.Width := 88;
    IsClassTributariaSearch.Height := 21;
    IsClassTributariaSearch.ChildOrder := 21;
    IsClassTributariaSearch.HeightPercent := 100.000000000000000000;
    IsClassTributariaSearch.TabOrder := 3;
    IsClassTributariaSearch.WidthPercent := 100.000000000000000000;
    SetEvent(IsClassTributariaSearch, Self, 'OnKeyDown', 'IsClassTributariaSearchKeyDown');
    SetEvent(IsClassTributariaSearch, Self, 'OnKeyUp', 'IsClassTributariaSearchKeyUp');
    tblIsClassTributaria.SetParentComponent(Self);
    tblIsClassTributaria.Name := 'tblIsClassTributaria';
    tblIsClassTributaria.Left := 344;
    tblIsClassTributaria.Top := 58;
    tblIsClassTributaria.Width := 335;
    tblIsClassTributaria.Height := 143;
    tblIsClassTributaria.ElementClassName := 'table-responsive';
    tblIsClassTributaria.BorderColor := clSilver;
    tblIsClassTributaria.ChildOrder := 19;
    tblIsClassTributaria.ColHeader := False;
    tblIsClassTributaria.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(tblIsClassTributaria, Self, 'OnGetCellData', 'tblIsClassTributariaGetCellData');
    SetEvent(tblIsClassTributaria, Self, 'OnGetCellChildren', 'tblIsClassTributariaGetCellChildren');
    SetEvent(tblIsClassTributaria, Self, 'OnGetCellClass', 'tblIsClassTributariaGetCellClass');
    tblIsClassTributaria.Columns.Clear;
    with tblIsClassTributaria.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with tblIsClassTributaria.Columns.Add do
    begin
      DataField := 'id';
      Title := 'C'#243'd.';
    end;
    with tblIsClassTributaria.Columns.Add do
    begin
      DataField := 'cclasstrib';
      Title := 'CClassTrib';
    end;
    with tblIsClassTributaria.Columns.Add do
    begin
      DataField := 'descricao';
      Title := 'Descri'#231#227'o';
    end;
    with tblIsClassTributaria.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with tblIsClassTributaria.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with tblIsClassTributaria.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with tblIsClassTributaria.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    tblIsClassTributaria.DataSource := dtsIsClassTributaria;
    wlcIsClassTributaria.SetParentComponent(Self);
    wlcIsClassTributaria.Name := 'wlcIsClassTributaria';
    wlcIsClassTributaria.Left := 491;
    wlcIsClassTributaria.Top := 216;
    wlcIsClassTributaria.Width := 188;
    wlcIsClassTributaria.Height := 15;
    wlcIsClassTributaria.HeightPercent := 100.000000000000000000;
    wlcIsClassTributaria.WidthPercent := 100.000000000000000000;
    wlcIsClassTributaria.ChildOrder := 24;
    wlcIsClassTributaria.DefaultItemClassName := 'page-item';
    wlcIsClassTributaria.DefaultItemLinkClassName := 'page-link';
    wlcIsClassTributaria.ElementListClassName := 'pagination';
    wlcIsClassTributaria.Items.Clear;
    with wlcIsClassTributaria.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with wlcIsClassTributaria.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with wlcIsClassTributaria.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    wlcIsClassTributaria.Style := lsPagination;
    pnlEspacoFormIsClassTributaria.SetParentComponent(Self);
    pnlEspacoFormIsClassTributaria.Name := 'pnlEspacoFormIsClassTributaria';
    pnlEspacoFormIsClassTributaria.Left := 8;
    pnlEspacoFormIsClassTributaria.Top := 312;
    pnlEspacoFormIsClassTributaria.Width := 671;
    pnlEspacoFormIsClassTributaria.Height := 17;
    pnlEspacoFormIsClassTributaria.Caption := 'Espa'#231'o form Rt Is Class Tributaria';
    pnlEspacoFormIsClassTributaria.ChildOrder := 23;
    pnlEspacoFormIsClassTributaria.Color := clInfoText;
    pnlEspacoFormIsClassTributaria.Font.Charset := DEFAULT_CHARSET;
    pnlEspacoFormIsClassTributaria.Font.Color := clWhite;
    pnlEspacoFormIsClassTributaria.Font.Height := -11;
    pnlEspacoFormIsClassTributaria.Font.Name := 'Tahoma';
    pnlEspacoFormIsClassTributaria.Font.Style := [fsBold];
    pnlEspacoFormIsClassTributaria.ParentFont := False;
    pnlEspacoFormIsClassTributaria.TabOrder := 17;
    pnlEspacoFormIsClassTributaria.Visible := False;
    btnNovo.SetParentComponent(Self);
    btnNovo.Name := 'btnNovo';
    btnNovo.Left := 488;
    btnNovo.Top := 520;
    btnNovo.Width := 96;
    btnNovo.Height := 25;
    btnNovo.Caption := 'Novo';
    btnNovo.ChildOrder := 50;
    btnNovo.HeightPercent := 100.000000000000000000;
    btnNovo.WidthPercent := 100.000000000000000000;
    SetEvent(btnNovo, Self, 'OnClick', 'btnNovoClick');
    btnSalvarClassTrib.SetParentComponent(Self);
    btnSalvarClassTrib.Name := 'btnSalvarClassTrib';
    btnSalvarClassTrib.Left := 485;
    btnSalvarClassTrib.Top := 551;
    btnSalvarClassTrib.Width := 99;
    btnSalvarClassTrib.Height := 25;
    btnSalvarClassTrib.Caption := 'Salvar';
    btnSalvarClassTrib.ChildOrder := 51;
    btnSalvarClassTrib.HeightPercent := 100.000000000000000000;
    btnSalvarClassTrib.TabOrder := 4;
    btnSalvarClassTrib.WidthPercent := 100.000000000000000000;
    SetEvent(btnSalvarClassTrib, Self, 'OnClick', 'btnSalvarClassTribClick');
    edid_classtrib.SetParentComponent(Self);
    edid_classtrib.Name := 'edid_classtrib';
    edid_classtrib.Left := 149;
    edid_classtrib.Top := 333;
    edid_classtrib.Width := 150;
    edid_classtrib.Height := 21;
    edid_classtrib.ChildOrder := 27;
    edid_classtrib.Enabled := False;
    edid_classtrib.HeightPercent := 100.000000000000000000;
    edid_classtrib.TabOrder := 6;
    edid_classtrib.Text := 'edid';
    edid_classtrib.WidthPercent := 100.000000000000000000;
    edid_classtrib.DataField := 'id';
    edid_classtrib.DataSource := dtsIsClassTributariaEdit;
    edcclasstrib.SetParentComponent(Self);
    edcclasstrib.Name := 'edcclasstrib';
    edcclasstrib.Left := 149;
    edcclasstrib.Top := 387;
    edcclasstrib.Width := 150;
    edcclasstrib.Height := 21;
    edcclasstrib.ChildOrder := 31;
    edcclasstrib.HeightPercent := 100.000000000000000000;
    edcclasstrib.MaxLength := 6;
    edcclasstrib.TabOrder := 8;
    edcclasstrib.Text := 'edcclasstrib';
    edcclasstrib.WidthPercent := 100.000000000000000000;
    SetEvent(edcclasstrib, Self, 'OnClick', 'edcclasstribClick');
    SetEvent(edcclasstrib, Self, 'OnKeyPress', 'edcclasstribKeyPress');
    edcclasstrib.DataField := 'cclasstrib';
    edcclasstrib.DataSource := dtsIsClassTributariaEdit;
    cbbIsCstId.SetParentComponent(Self);
    cbbIsCstId.Name := 'cbbIsCstId';
    cbbIsCstId.Left := 149;
    cbbIsCstId.Top := 360;
    cbbIsCstId.Width := 150;
    cbbIsCstId.Height := 21;
    cbbIsCstId.HeightPercent := 100.000000000000000000;
    cbbIsCstId.WidthPercent := 100.000000000000000000;
    SetEvent(cbbIsCstId, Self, 'OnClick', 'cbbIsCstIdClick');
    cbbIsCstId.ItemIndex := -1;
    eddescricao_classtrib.SetParentComponent(Self);
    eddescricao_classtrib.Name := 'eddescricao_classtrib';
    eddescricao_classtrib.Left := 149;
    eddescricao_classtrib.Top := 414;
    eddescricao_classtrib.Width := 150;
    eddescricao_classtrib.Height := 21;
    eddescricao_classtrib.ChildOrder := 33;
    eddescricao_classtrib.HeightPercent := 100.000000000000000000;
    eddescricao_classtrib.TabOrder := 9;
    eddescricao_classtrib.Text := 'eddescricao';
    eddescricao_classtrib.WidthPercent := 100.000000000000000000;
    SetEvent(eddescricao_classtrib, Self, 'OnClick', 'eddescricao_classtribClick');
    eddescricao_classtrib.DataField := 'descricao';
    eddescricao_classtrib.DataSource := dtsIsClassTributariaEdit;
    edinclusao_classtrib.SetParentComponent(Self);
    edinclusao_classtrib.Name := 'edinclusao_classtrib';
    edinclusao_classtrib.Left := 477;
    edinclusao_classtrib.Top := 360;
    edinclusao_classtrib.Width := 150;
    edinclusao_classtrib.Height := 21;
    edinclusao_classtrib.ChildOrder := 45;
    edinclusao_classtrib.Enabled := False;
    edinclusao_classtrib.HeightPercent := 100.000000000000000000;
    edinclusao_classtrib.TabOrder := 15;
    edinclusao_classtrib.Text := 'edinclusao';
    edinclusao_classtrib.WidthPercent := 100.000000000000000000;
    edinclusao_classtrib.DataField := 'inclusao';
    edinclusao_classtrib.DataSource := dtsIsClassTributariaEdit;
    edalteracao_classtrib.SetParentComponent(Self);
    edalteracao_classtrib.Name := 'edalteracao_classtrib';
    edalteracao_classtrib.Left := 477;
    edalteracao_classtrib.Top := 387;
    edalteracao_classtrib.Width := 150;
    edalteracao_classtrib.Height := 21;
    edalteracao_classtrib.ChildOrder := 47;
    edalteracao_classtrib.Enabled := False;
    edalteracao_classtrib.HeightPercent := 100.000000000000000000;
    edalteracao_classtrib.TabOrder := 16;
    edalteracao_classtrib.Text := 'edalteracao';
    edalteracao_classtrib.WidthPercent := 100.000000000000000000;
    edalteracao_classtrib.DataField := 'alteracao';
    edalteracao_classtrib.DataSource := dtsIsClassTributariaEdit;
    ed_exclusao.SetParentComponent(Self);
    ed_exclusao.Name := 'ed_exclusao';
    ed_exclusao.Left := 477;
    ed_exclusao.Top := 414;
    ed_exclusao.Width := 150;
    ed_exclusao.Height := 21;
    ed_exclusao.ChildOrder := 49;
    ed_exclusao.Enabled := False;
    ed_exclusao.HeightPercent := 100.000000000000000000;
    ed_exclusao.TabOrder := 17;
    ed_exclusao.Text := 'edexclusao';
    ed_exclusao.WidthPercent := 100.000000000000000000;
    ed_exclusao.DataField := 'exclusao';
    ed_exclusao.DataSource := dtsIsClassTributariaEdit;
    cbExcluidoClassTrib.SetParentComponent(Self);
    cbExcluidoClassTrib.Name := 'cbExcluidoClassTrib';
    cbExcluidoClassTrib.Left := 477;
    cbExcluidoClassTrib.Top := 332;
    cbExcluidoClassTrib.Width := 150;
    cbExcluidoClassTrib.Height := 22;
    cbExcluidoClassTrib.Caption := 'cbExcluido';
    cbExcluidoClassTrib.ChildOrder := 13;
    cbExcluidoClassTrib.HeightPercent := 100.000000000000000000;
    cbExcluidoClassTrib.WidthPercent := 100.000000000000000000;
    cbExcluidoClassTrib.DataField := 'excluido';
    cbExcluidoClassTrib.DataSource := dtsIsClassTributariaEdit;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Rt_Is_CstDataset;
    DataSource.Left := 264;
    DataSource.Top := 136;
    Rt_Is_CstDataset.SetParentComponent(Self);
    Rt_Is_CstDataset.Name := 'Rt_Is_CstDataset';
    Rt_Is_CstDataset.AfterApplyUpdates := Rt_Is_CstDatasetAfterApplyUpdates;
    Rt_Is_CstDataset.AfterOpen := Rt_Is_CstDatasetAfterOpen;
    Rt_Is_CstDataset.EntitySetName := 'Rt_Is_Cst';
    Rt_Is_CstDataset.Connection := DMConnection.ApiConnection;
    Rt_Is_CstDataset.Left := 224;
    Rt_Is_CstDataset.Top := 136;
    Rt_Is_CstDatasetid.SetParentComponent(Rt_Is_CstDataset);
    Rt_Is_CstDatasetid.Name := 'Rt_Is_CstDatasetid';
    Rt_Is_CstDatasetid.FieldName := 'id';
    Rt_Is_CstDatasetcst.SetParentComponent(Rt_Is_CstDataset);
    Rt_Is_CstDatasetcst.Name := 'Rt_Is_CstDatasetcst';
    Rt_Is_CstDatasetcst.FieldName := 'cst';
    Rt_Is_CstDatasetcst.Required := True;
    Rt_Is_CstDatasetcst.Size := 255;
    Rt_Is_CstDatasetdescricao.SetParentComponent(Rt_Is_CstDataset);
    Rt_Is_CstDatasetdescricao.Name := 'Rt_Is_CstDatasetdescricao';
    Rt_Is_CstDatasetdescricao.FieldName := 'descricao';
    Rt_Is_CstDatasetdescricao.Required := True;
    Rt_Is_CstDatasetdescricao.Size := 255;
    Rt_Is_CstDatasetexcluido.SetParentComponent(Rt_Is_CstDataset);
    Rt_Is_CstDatasetexcluido.Name := 'Rt_Is_CstDatasetexcluido';
    Rt_Is_CstDatasetexcluido.FieldName := 'excluido';
    Rt_Is_CstDatasetinclusao.SetParentComponent(Rt_Is_CstDataset);
    Rt_Is_CstDatasetinclusao.Name := 'Rt_Is_CstDatasetinclusao';
    Rt_Is_CstDatasetinclusao.FieldName := 'inclusao';
    Rt_Is_CstDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Rt_Is_CstDatasetalteracao.SetParentComponent(Rt_Is_CstDataset);
    Rt_Is_CstDatasetalteracao.Name := 'Rt_Is_CstDatasetalteracao';
    Rt_Is_CstDatasetalteracao.FieldName := 'alteracao';
    Rt_Is_CstDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Rt_Is_CstDatasetexclusao.SetParentComponent(Rt_Is_CstDataset);
    Rt_Is_CstDatasetexclusao.Name := 'Rt_Is_CstDatasetexclusao';
    Rt_Is_CstDatasetexclusao.FieldName := 'exclusao';
    Rt_Is_CstDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    XDataClientRt_Is_CstGet.SetParentComponent(Self);
    XDataClientRt_Is_CstGet.Name := 'XDataClientRt_Is_CstGet';
    XDataClientRt_Is_CstGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientRt_Is_CstGet, Self, 'OnLoad', 'XDataClientRt_Is_CstGetLoad');
    XDataClientRt_Is_CstGet.Left := 232;
    XDataClientRt_Is_CstGet.Top := 176;
    dtsIsClassTributaria.SetParentComponent(Self);
    dtsIsClassTributaria.Name := 'dtsIsClassTributaria';
    dtsIsClassTributaria.DataSet := cdsIsClassTributaria;
    dtsIsClassTributaria.Left := 360;
    dtsIsClassTributaria.Top := 248;
    cdsIsClassTributaria.SetParentComponent(Self);
    cdsIsClassTributaria.Name := 'cdsIsClassTributaria';
    cdsIsClassTributaria.EntitySetName := 'Rt_Is_Class_Tributaria';
    cdsIsClassTributaria.Connection := DMConnection.ApiConnection;
    cdsIsClassTributaria.Left := 456;
    cdsIsClassTributaria.Top := 248;
    cdsIsClassTributariaid.SetParentComponent(cdsIsClassTributaria);
    cdsIsClassTributariaid.Name := 'cdsIsClassTributariaid';
    cdsIsClassTributariaid.FieldName := 'id';
    cdsIsClassTributariaid.Required := True;
    cdsIsClassTributariart_is_cst_id.SetParentComponent(cdsIsClassTributaria);
    cdsIsClassTributariart_is_cst_id.Name := 'cdsIsClassTributariart_is_cst_id';
    cdsIsClassTributariart_is_cst_id.FieldName := 'rt_is_cst_id';
    cdsIsClassTributariart_is_cst_id.Required := True;
    cdsIsClassTributariacclasstrib.SetParentComponent(cdsIsClassTributaria);
    cdsIsClassTributariacclasstrib.Name := 'cdsIsClassTributariacclasstrib';
    cdsIsClassTributariacclasstrib.FieldName := 'cclasstrib';
    cdsIsClassTributariacclasstrib.Required := True;
    cdsIsClassTributariacclasstrib.Size := 255;
    cdsIsClassTributariadescricao.SetParentComponent(cdsIsClassTributaria);
    cdsIsClassTributariadescricao.Name := 'cdsIsClassTributariadescricao';
    cdsIsClassTributariadescricao.FieldName := 'descricao';
    cdsIsClassTributariadescricao.Required := True;
    cdsIsClassTributariadescricao.Size := 255;
    cdsIsClassTributariaexcluido.SetParentComponent(cdsIsClassTributaria);
    cdsIsClassTributariaexcluido.Name := 'cdsIsClassTributariaexcluido';
    cdsIsClassTributariaexcluido.FieldName := 'excluido';
    cdsIsClassTributariainclusao.SetParentComponent(cdsIsClassTributaria);
    cdsIsClassTributariainclusao.Name := 'cdsIsClassTributariainclusao';
    cdsIsClassTributariainclusao.FieldName := 'inclusao';
    cdsIsClassTributariainclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsIsClassTributariaalteracao.SetParentComponent(cdsIsClassTributaria);
    cdsIsClassTributariaalteracao.Name := 'cdsIsClassTributariaalteracao';
    cdsIsClassTributariaalteracao.FieldName := 'alteracao';
    cdsIsClassTributariaalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    cdsIsClassTributariaexclusao.SetParentComponent(cdsIsClassTributaria);
    cdsIsClassTributariaexclusao.Name := 'cdsIsClassTributariaexclusao';
    cdsIsClassTributariaexclusao.FieldName := 'exclusao';
    cdsIsClassTributariaexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    tmrConsultaIsClassTributaria.SetParentComponent(Self);
    tmrConsultaIsClassTributaria.Name := 'tmrConsultaIsClassTributaria';
    tmrConsultaIsClassTributaria.Enabled := False;
    SetEvent(tmrConsultaIsClassTributaria, Self, 'OnTimer', 'tmrConsultaIsClassTributariaTimer');
    tmrConsultaIsClassTributaria.Left := 584;
    tmrConsultaIsClassTributaria.Top := 232;
    cdsIsClassTributariaEdit.SetParentComponent(Self);
    cdsIsClassTributariaEdit.Name := 'cdsIsClassTributariaEdit';
    cdsIsClassTributariaEdit.AfterApplyUpdates := cdsIsClassTributariaEditAfterApplyUpdates;
    cdsIsClassTributariaEdit.AfterOpen := cdsIsClassTributariaEditAfterOpen;
    cdsIsClassTributariaEdit.EntitySetName := 'Rt_Is_Class_Tributaria';
    cdsIsClassTributariaEdit.Connection := DMConnection.ApiConnection;
    cdsIsClassTributariaEdit.Left := 128;
    cdsIsClassTributariaEdit.Top := 496;
    IntegerField1.SetParentComponent(cdsIsClassTributariaEdit);
    IntegerField1.Name := 'IntegerField1';
    IntegerField1.FieldName := 'id';
    IntegerField2.SetParentComponent(cdsIsClassTributariaEdit);
    IntegerField2.Name := 'IntegerField2';
    IntegerField2.FieldName := 'rt_is_cst_id';
    StringField1.SetParentComponent(cdsIsClassTributariaEdit);
    StringField1.Name := 'StringField1';
    StringField1.FieldName := 'cclasstrib';
    StringField1.Size := 255;
    StringField2.SetParentComponent(cdsIsClassTributariaEdit);
    StringField2.Name := 'StringField2';
    StringField2.FieldName := 'descricao';
    StringField2.Size := 255;
    BooleanField1.SetParentComponent(cdsIsClassTributariaEdit);
    BooleanField1.Name := 'BooleanField1';
    BooleanField1.FieldName := 'excluido';
    DateTimeField1.SetParentComponent(cdsIsClassTributariaEdit);
    DateTimeField1.Name := 'DateTimeField1';
    DateTimeField1.FieldName := 'inclusao';
    DateTimeField1.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    DateTimeField2.SetParentComponent(cdsIsClassTributariaEdit);
    DateTimeField2.Name := 'DateTimeField2';
    DateTimeField2.FieldName := 'alteracao';
    DateTimeField2.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    DateTimeField3.SetParentComponent(cdsIsClassTributariaEdit);
    DateTimeField3.Name := 'DateTimeField3';
    DateTimeField3.FieldName := 'exclusao';
    DateTimeField3.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    dtsIsClassTributariaEdit.SetParentComponent(Self);
    dtsIsClassTributariaEdit.Name := 'dtsIsClassTributariaEdit';
    dtsIsClassTributariaEdit.DataSet := cdsIsClassTributariaEdit;
    dtsIsClassTributariaEdit.Left := 280;
    dtsIsClassTributariaEdit.Top := 496;
    cdsIsCst.SetParentComponent(Self);
    cdsIsCst.Name := 'cdsIsCst';
    cdsIsCst.AfterOpen := cdsIsCstAfterOpen;
    cdsIsCst.EntitySetName := 'Rt_Is_Cst';
    cdsIsCst.Connection := DMConnection.ApiConnection;
    cdsIsCst.QueryTop := 100;
    cdsIsCst.Left := 400;
    cdsIsCst.Top := 464;
    cdsIsCstid.SetParentComponent(cdsIsCst);
    cdsIsCstid.Name := 'cdsIsCstid';
    cdsIsCstid.FieldName := 'id';
    cdsIsCstid.Required := True;
    cdsIsCstdescricao.SetParentComponent(cdsIsCst);
    cdsIsCstdescricao.Name := 'cdsIsCstdescricao';
    cdsIsCstdescricao.FieldName := 'descricao';
    cdsIsCstdescricao.Required := True;
    cdsIsCstdescricao.Size := 255;
    cdsIsCstcst.SetParentComponent(cdsIsCst);
    cdsIsCstcst.Name := 'cdsIsCstcst';
    cdsIsCstcst.FieldName := 'cst';
    cdsIsCstcst.Required := True;
    cdsIsCstcst.Size := 255;
  finally
    lbid.AfterLoadDFMValues;
    lbcst.AfterLoadDFMValues;
    lbdescricao.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    lbTotalIsClassTributaria.AfterLoadDFMValues;
    lbid_classtrib.AfterLoadDFMValues;
    lbrt_is_cst_id.AfterLoadDFMValues;
    lbcclasstrib.AfterLoadDFMValues;
    lbdescricao_classtrib.AfterLoadDFMValues;
    lbexcluido_classtrib.AfterLoadDFMValues;
    lbinclusao_classtrib.AfterLoadDFMValues;
    lbalteracao_classtrib.AfterLoadDFMValues;
    lbexclusao_classtrib.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edcst.AfterLoadDFMValues;
    eddescricao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbExcluido.AfterLoadDFMValues;
    pnlEspacoFormRtIsCst.AfterLoadDFMValues;
    btnRtIsCst.AfterLoadDFMValues;
    btnIsClassTributaria.AfterLoadDFMValues;
    pnlIsClassTributaria.AfterLoadDFMValues;
    cbPageSizeIsClassTributaria.AfterLoadDFMValues;
    IsClassTributariaSearch.AfterLoadDFMValues;
    tblIsClassTributaria.AfterLoadDFMValues;
    wlcIsClassTributaria.AfterLoadDFMValues;
    pnlEspacoFormIsClassTributaria.AfterLoadDFMValues;
    btnNovo.AfterLoadDFMValues;
    btnSalvarClassTrib.AfterLoadDFMValues;
    edid_classtrib.AfterLoadDFMValues;
    edcclasstrib.AfterLoadDFMValues;
    cbbIsCstId.AfterLoadDFMValues;
    eddescricao_classtrib.AfterLoadDFMValues;
    edinclusao_classtrib.AfterLoadDFMValues;
    edalteracao_classtrib.AfterLoadDFMValues;
    ed_exclusao.AfterLoadDFMValues;
    cbExcluidoClassTrib.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Rt_Is_CstDataset.AfterLoadDFMValues;
    Rt_Is_CstDatasetid.AfterLoadDFMValues;
    Rt_Is_CstDatasetcst.AfterLoadDFMValues;
    Rt_Is_CstDatasetdescricao.AfterLoadDFMValues;
    Rt_Is_CstDatasetexcluido.AfterLoadDFMValues;
    Rt_Is_CstDatasetinclusao.AfterLoadDFMValues;
    Rt_Is_CstDatasetalteracao.AfterLoadDFMValues;
    Rt_Is_CstDatasetexclusao.AfterLoadDFMValues;
    XDataClientRt_Is_CstGet.AfterLoadDFMValues;
    dtsIsClassTributaria.AfterLoadDFMValues;
    cdsIsClassTributaria.AfterLoadDFMValues;
    cdsIsClassTributariaid.AfterLoadDFMValues;
    cdsIsClassTributariart_is_cst_id.AfterLoadDFMValues;
    cdsIsClassTributariacclasstrib.AfterLoadDFMValues;
    cdsIsClassTributariadescricao.AfterLoadDFMValues;
    cdsIsClassTributariaexcluido.AfterLoadDFMValues;
    cdsIsClassTributariainclusao.AfterLoadDFMValues;
    cdsIsClassTributariaalteracao.AfterLoadDFMValues;
    cdsIsClassTributariaexclusao.AfterLoadDFMValues;
    tmrConsultaIsClassTributaria.AfterLoadDFMValues;
    cdsIsClassTributariaEdit.AfterLoadDFMValues;
    IntegerField1.AfterLoadDFMValues;
    IntegerField2.AfterLoadDFMValues;
    StringField1.AfterLoadDFMValues;
    StringField2.AfterLoadDFMValues;
    BooleanField1.AfterLoadDFMValues;
    DateTimeField1.AfterLoadDFMValues;
    DateTimeField2.AfterLoadDFMValues;
    DateTimeField3.AfterLoadDFMValues;
    dtsIsClassTributariaEdit.AfterLoadDFMValues;
    cdsIsCst.AfterLoadDFMValues;
    cdsIsCstid.AfterLoadDFMValues;
    cdsIsCstdescricao.AfterLoadDFMValues;
    cdsIsCstcst.AfterLoadDFMValues;
  end;
end;

end.
